import React from 'react';
import VendorsHero from '../components/VendorsHero';
import VendorsAdvantages from '../components/VendorsAdvantages';
import VendorsTestimonials from '../components/VendorsTestimonials';
import VendorsAnalytics from '../components/VendorsAnalytics';

import VendorsGrowth from '../components/VendorsGrowth';
import VendorsCTA from '../components/VendorsCTA';
import ProductIcons from '@/components/ProductIcons';
import WhyDailzySaathi from '@/components/WhyDailzySaathi';
import SEO from '@/components/SEO';

const Vendors: React.FC = () => {
  const vendorStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Vendor Partnership Program - Dailzy",
    "description": "Join 15K+ vendors on Dailzy and grow your business with our quick commerce platform",
    "mainEntity": {
      "@type": "BusinessFunction",
      "name": "Vendor Partnership Program",
      "description": "Partner with Dailzy to expand your business reach and increase sales through our quick commerce platform",
      "provider": {
        "@type": "Organization",
        "name": "Dailzy"
      },
      "offers": {
        "@type": "Offer",
        "name": "Vendor Partnership",
        "description": "Zero setup cost, minimal commission, instant payments, and access to 500K+ customers",
        "eligibility": "Local businesses, grocers, pharmacies, electronics stores",
        "businessFunction": "Sales",
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Vendor Benefits",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Zero Setup Cost"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Minimal Commission"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Instant Payment Settlement"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "Marketing Support"
              }
            }
          ]
        }
      }
    }
  };

  return (
    <div className="min-h-screen w-full overflow-x-hidden">
      <SEO
        title="Vendor Partnership Program - Join 15K+ Vendors on Dailzy | Grow Your Business"
        description="Partner with Dailzy and reach 500K+ customers instantly. Zero setup cost, minimal commission, instant payments. Join 15K+ successful vendors across 50+ cities in India."
        keywords="vendor partnership, join dailzy vendor, become seller, quick commerce vendor, local business partnership, vendor registration, sell online, hyperlocal selling, vendor benefits"
        url="https://dailzy.com/vendors"
        type="website"
        structuredData={vendorStructuredData}
      />
      
      <main className="w-full overflow-x-hidden">
        <section id="vendors-hero" aria-label="Vendors Hero Section">
          <VendorsHero />
        </section>
        
        <section id="vendor-advantages" aria-label="Vendor Advantages Section">
          <h2 className="sr-only">Vendor Advantages</h2>
          <VendorsAdvantages />
        </section>
        
        <ProductIcons />
        <VendorsAnalytics />
        <WhyDailzySaathi />
        <VendorsTestimonials />
        {/* <VendorsGrowth /> */}
        <VendorsCTA />
      </main>
    </div>
  );
};

export default Vendors; 